document.addEventListener("turbolinks:load", () => {
    flatpickr('.datepicker')
    $('form.reports input.filter,form.reports select.filter').change( () => {
        console.log('submit!')
        $('form.reports').submit()
      }
    )
  }
)